/**
 * Airline landing pages — same layout as Southwest; copy comes from content.js.
 * Paths: /{slug}-airlines-reservations and /{slug}-airlines-reservations/search
 * Optional `theme` switches the page colours (see airline-themes.css).
 */

export const AIRLINE_LANDINGS = [
  { slug: 'southwest', name: 'Southwest Airlines', shortName: 'Southwest' },
  { slug: 'jetblue', name: 'JetBlue Airways', shortName: 'JetBlue', theme: 'sky' },
  { slug: 'alaska', name: 'Alaska Airlines', shortName: 'Alaska', theme: 'sky' },
];

export function airlinePath(slug) {
  return `/${slug}-airlines-reservations`;
}

export function airlineResultsPath(slug) {
  return `${airlinePath(slug)}/search`;
}

export function getAirlineBySlug(slug) {
  return AIRLINE_LANDINGS.find((airline) => airline.slug === slug) ?? null;
}

export function isAirlinePath(pathname) {
  return AIRLINE_LANDINGS.some((airline) => pathname.startsWith(airlinePath(airline.slug)));
}

/** Root class list for a landing page, plus the airline's colour theme when it has one. */
export function airlineThemeClass(base, airline) {
  return airline?.theme ? `${base} swp--theme-${airline.theme}` : base;
}
